// angular
//     .module("HeroPRO")
//     .controller("PaymentInstructionsWalkthroughController", paymentInstructionsWalkthroughController);

import _ from 'lodash';

/* @ngInject */
export default function paymentInstructionsWalkthroughController($scope, $state, $stateParams, FRInformationFactory, FRClosingFactory, HPStateMachineConfig, raSpinnerService) {
    const vm = this;
    vm.stateMachineData = {};
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.totalLabel = 'Total';
    vm.contractorLocationOfficeId = "";

    init();

    vm.confirmPaymentInstructions = function () {
        raSpinnerService.show('walkthroughSpinner');

        const params = {
            PaymentInstructions: {
                FundingRequestId: $stateParams.appId,
            },
        };

        FRClosingFactory.confirmPaymentInstructions(params).then((response) => {
            FRInformationFactory.setStateMachineData(response.data.Data.PipelineStageId, response.data.Data.FundingRequestPipelineStageId, response.data.Data.LoanStateId, response.data.Data.FundingRequestStateId, response.data.Data.CompletionCertificateStateId);
            FRClosingFactory.setPaymentInstructions(_.omit(response.data.Data, 'FundingRequestId', 'LoanStateId'));
            // Refresh the page so that the information for the newly generated CC is available on the page
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        });
    };

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });


        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            
            const contractorId = FRClosingFactory.getFundingRequest().FundingRequestDetail.ContractorId || "";
            
            vm.contractorOfficeLocationId = contractorId;
            
            const contractorDisbursement = _.find(FRClosingFactory.getPaymentInstructions().newDisbursements, disbursement => disbursement.PayeeType === 'Contractor');

            if (contractorDisbursement) {
                vm.totalLabel = 'Payment to Contractor';
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/getPaid/paymentInstructionsWalkthroughController.js